import React, {Component} from 'react';
import {Modal} from 'react-bootstrap';
import axios from 'axios';

export default class ReviewsExistModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            loading: false,
            error: null,
        };

        this.onClose = this.onClose.bind(this);
        this.onConfirm = this.onConfirm.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.show === this.props.show) {
            return;
        }
        this.setState({
            loading: false,
            error: null,
        });
    }

    onClose() {
        this.props.onClose();
    }

    onConfirm() {
        const {competitionId} = this.props;

        const url = `/competitions/reset-reviews/${competitionId}`;

        this.setState({
            loading: true,
            error: null,
        }, () => {
            axios
                .post(url)
                .then(() => {
                    this.props.onConfirm();
                })
                .catch(() => {
                    this.setState({
                        loading: false,
                        error: window.__js_general.action_failed_try_later,
                    });
                });
        });
    }

    render() {
        return (
            <Modal show={this.props.show}
                   onHide={this.onClose}>
                <Modal.Header closeButton>
                    <Modal.Title>{window.__js_bid_reviews.change_reviewers}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>{window.__js_bid_reviews.competition_has_review_warning}</p>

                    <p className="text-bold text-warning">
                       {window.__js_bid_reviews.competition_review_again_warning}
                    </p>

                    <p>{window.__js_bid_reviews.continue_verify}</p>

                    {
                        this.state.error
                            ? <p className="text-bold text-danger">
                                <i className="fa fa-fw fa-times"></i>
                                {this.state.error}
                            </p>
                            : null
                    }
                </Modal.Body>
                <Modal.Footer>
                    <button className="btn btn-default" onClick={this.onClose}>
                        {window.__js_general.no_literal}
                    </button>
                    <button className="btn btn-primary" onClick={this.onConfirm} disabled={this.state.loading}>
                        {window.__js_general.yes_literal}
                    </button>
                </Modal.Footer>
            </Modal>
        );
    }
}